package com.crowpay.extensions

import com.crowpay.LineItem
import com.crowpay.completionResponse.CompletionResponse
import com.crowpay.utils.renderDollars

fun CompletionResponse.NeedsApproval.actionName() = when (this) {
    is CompletionResponse.RequestComplete -> "Approve Work"
    is CompletionResponse.ForceComplete -> "Accept $displayName"
    is CompletionResponse.Handled -> "Accept $displayName"
    CompletionResponse.Appeal -> "Accept Appeal"
    is CompletionResponse.Credit -> "Accept Credit (${credit.renderDollars()})"
    is CompletionResponse.Remedy -> "Accept $displayName"
    is CompletionResponse.Remedy.RemedyComplete -> "Approve Work"
    CompletionResponse.RequestResolveLater -> "Resolve Later"
    is CompletionResponse.RequestSiteVisit -> "Confirm Visit"
}

fun CompletionResponse.NeedsApproval.confirmationText(lineItem: LineItem) = when (this) {
    is CompletionResponse.ForceComplete,
    is CompletionResponse.Handled,
    is CompletionResponse.RequestComplete -> Triple(
        "Approve & Pay ${lineItem.name}?",
        "Approving this work item releases funds to the contractor as payment.",
        "Approve & Pay"
    )
    CompletionResponse.Appeal -> Triple(
        "Accept Appeal and Pay ${lineItem.name}?",
        "Approving this work item releases funds to the contractor as payment.",
        "Approve & Pay"
    )
    is CompletionResponse.Credit -> Triple(
        "Accept Credit and Pay Out ${lineItem.name}?",
        "This will apply a ${credit.renderDollars()} credit to the work item and then pay out the remaining balance to the contractor.",
        "Approve & Pay"
    )
    is CompletionResponse.Remedy -> Triple(
        "Approve Remedy Plan?",
        "The contractor will begin work on this plan once approved, and then request sign off once he feels the Remedy has been completed. It was also apply any proposed credit to the line item when the work is done.",
        "Approve Remedy and Start Work"
    )
    CompletionResponse.RequestResolveLater -> Triple(
        "Resolve Later?",
        "This will stop any work and funds release for the line item. At the end of the project the line item will be revisited and problems addressed.",
        "Resolve Later"
    )
    is CompletionResponse.Remedy.RemedyComplete -> Triple(
        "Accept Complete & Pay ${lineItem.name}?",
        "Approving this will complete the line item and apply ${remedy.credit.renderDollars()} of credit to the line item. It will then pay out the remaining balance to the contractor.",
        "Accept Complete"
    )
    is CompletionResponse.RequestSiteVisit -> Triple(
        "Confirm Visit",
        "Communicate with the contractor to determine when you want to meet at the jobsite.",
        "Confirm Visit"
    )
}